import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Lang } from './shared/lang';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'corp-outlet-ui';

  constructor(
    private translate: TranslateService
  ) {
    this.translate.addLangs(Object.values(Lang));
    this.translate.use(Lang.en);
  }

}
